import { IcoRadio } from "assets/icons";
import { Fragment, InputHTMLAttributes } from "react";

export interface RadioOption {
	label: React.ReactNode;
	value: string;
}

type RadioInputProps = InputHTMLAttributes<HTMLInputElement> & {
	label?: string;
	error?: string | Array<string>;
	className?: string;
	touched?: boolean;
	options: RadioOption[];
	isRequired?: boolean;
	layout?: "horizontal" | "vertical";
};

export default function RadioInput({
	name,
	label,
	value,
	onChange,
	options,
	className,
	touched,
	error,
	isRequired = true,
	layout = "horizontal"
}: RadioInputProps): JSX.Element {
	return (
		<fieldset
			className={`container ${className || ""} ${
				layout === "horizontal" ? "flex flex-row gap-6 justify-start align-center" : "flex flex-col gap-2"
			}`}
		>
			<div className={layout === "vertical" ? "mb-2" : ""}>
				{label && <span className="font-medium">{label}</span>}
				{isRequired && <span className="text-feedback-negative-pure-500"> *</span>}
			</div>

			<div className={layout === "horizontal" ? "flex flex-row gap-6" : "flex flex-col gap-2 pl-1"}>
				{options.map((option) => (
					<Fragment key={option.value}>
						<input
							id={`${name}-${option.value}`}
							name={name}
							value={option.value}
							onChange={onChange}
							type="radio"
							checked={option.value === value}
							hidden
						/>
						<label
							htmlFor={`${name}-${option.value}`}
							className={`flex flex-row gap-2 items-center cursor-pointer ${
								error && touched
									? "bg-feedback-negative-high-50 border-feedback-negative-pure-500 focus-visible:outline-feedback-negative-pure-500"
									: ""
							}`}
						>
							<IcoRadio filled={option.value === value} />
							<span>{option.label}</span>
						</label>
					</Fragment>
				))}
			</div>

			{error && touched && (
				<div className="white-space--pre-line mt-1 text-xs text-feedback-negative-pure-500">
					{Array.isArray(error) ? error.join("\n") : error}
				</div>
			)}
		</fieldset>
	);
}
